
"use client";

import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Info, Settings2 } from "lucide-react"; // Changed icon

interface IntegrationInProgressModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function IntegrationInProgressModal({
  isOpen,
  onOpenChange,
}: IntegrationInProgressModalProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center">
            <Settings2 className="mr-2 h-5 w-5 text-primary animate-spin-slow" /> {/* Changed icon and added slow spin */}
            Payment Integration in Progress
          </AlertDialogTitle>
          <AlertDialogDescription className="pt-2 space-y-2">
            <p>
              We're currently fine-tuning our payment system to ensure a smooth and secure experience.
            </p>
            <p>
              This feature will be available very soon! Thank you for your understanding and patience.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => onOpenChange(false)} className="w-full sm:w-auto">
            Sounds Good!
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

// Add a simple animation for the icon if needed (can be done in globals.css or here)
// For simplicity, using a Tailwind utility if available or a simple keyframe.
// In globals.css or a style tag in this component:
// @keyframes spin-slow { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
// .animate-spin-slow { animation: spin-slow 3s linear infinite; }
// (Assuming tailwind.config.ts is extended for 'spin-slow')
// If not extending tailwind, you might need inline styles or a <style> tag if this component is self-contained.
// For now, I'll just add the class and assume it's defined in globals or tailwind.config for a slow spin.
// A simple way in tailwind.config.ts:
// theme: { extend: { animation: { 'spin-slow': 'spin 3s linear infinite' } } }
// For this exercise, I'll assume animate-spin-slow exists or can be added. If not, it'll just be a static icon.
